import type { ReactNode } from 'react';

import { cn } from '@nucleus-commerce/ui/lib/utils';

export interface PageContentProps {
  children: ReactNode;
  /** narrow: forms and detail pages. wide: tables and dashboards (default). */
  width?: 'narrow' | 'wide';
  className?: string;
}

export function PageContent({ children, width = 'wide', className }: PageContentProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full px-4 py-6 md:px-6',
        width === 'narrow' ? 'max-w-4xl' : 'max-w-7xl',
        className,
      )}
    >
      {children}
    </div>
  );
}
